module.exports = __webpack_public_path__ + "img/Folded_Paper-contact-banner.b2b69727.svg";